'use strict';

var Backbone = require('backbone');
var Radio = require('backbone.radio');
var polyglot = require('../utilities/polyglot').default;

var RescheduleView = require('../views/pages/reschedule').default;

export default Backbone.Router.extend({

  initialize: function (options) {
    this.route(encodeURIComponent(polyglot.t('pages.reschedule.slug')), 'reschedule');
    this.layout = options.layout;
    this.onReschedule = false;
    this.listenTo(Radio.channel('reschedule'), 'set:appointment', this.setAppointment);
    Radio.channel('reschedule').reply('here', this.isHere, this);
  },

  isHere: function() {
    return this.onReschedule;
  },

  setAppointment: function(appointment) {
    this.appointment = appointment;
  },

  reschedule: function () {
    if (this.appointment) {
      this.onReschedule = true;
      Radio.channel('steps').trigger('on');
      this.layout.getRegion('main').show(new RescheduleView({
        appointment: this.appointment,
      }));
    } else {
      Backbone.history.navigate('/', {trigger: true});
    }
  },
});
